import { useEffect, useState } from 'react'
import { LAYOUT_ID } from '../Layout.model'

export function useLayoutHeight() {
  const [height, setHeight] = useState(0)

  useEffect(() => {
    function updateHeight() {
      const element = document.getElementById(LAYOUT_ID)
      if (element) {
        setHeight(element.offsetHeight)
      }
    }

    updateHeight()
    window.addEventListener('resize', updateHeight)

    return () => {
      window.removeEventListener('resize', updateHeight)
    }
  }, [])

  return height
}
